<template>
    <section>
        <PageTitle title="Restaurant Menu" v-bind:crumbs="[{href:'/view_menu',title:'View Menu'}]" />
        <div class="wrapper wrapper-content">
            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                <div class="sk-bounce1"></div>
                <div class="sk-bounce2"></div>
                <div class="sk-bounce3"></div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Warehouse</label>
                        <multiselect v-model="selectedRestaurant" deselect-label="Can't remove this value" :allow-empty="false" :options="restaurants" label="name" track-by="name" @input="fetchBranchesAndAddonsCSV()"></multiselect>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Vendors</label>
                        <multiselect id="filter2" v-model="selectedBranch" deselect-label="Can't remove this value" :allow-empty="false" :options="branches" :custom-label="opt=> opt.areasByAreaId.name" track-by="id" @input="fetchBranchMenu()"></multiselect>
                    </div>
                </div>
            </div>

            <div v-if="selectedBranch" class="row" style="margin-bottom: 20px">
              <div class="col-md-12">
                <button v-if="menu.length > 0" v-on:click="updateMenu()" class="btn btn-md btn-primary"><i class="fa fa-pencil"></i> Update Menu</button> &emsp;
                <input id="fileUpload" type="file" accept=".csv" hidden style="display: none;" @change="handleFile($event)">
                <button v-on:click="uploadCSV( $event)" class="btn btn-md btn-primary"><i class="fa fa-folder"></i> Upload CSV</button>
                  <vue-json-to-csv v-if="(userRole === 'ROLE_ADMIN' || userRole === 'ROLE_AGENT')"
                                   style="margin-right: 20px"
                                   :csv-title=fetchFilename(selectedBranch.areasByAreaId.name)
                                   class="btn btn-primary pull-right"
                                   :json-data=branchMenuCsv
                  > Download Menu
                  </vue-json-to-csv>
                  <vue-json-to-csv v-if="(userRole === 'ROLE_ADMIN' || userRole === 'ROLE_AGENT')"
                                 style="margin-right: 20px"
                                 csv-title="brands"
                                 class="btn btn-primary pull-right"
                                 :json-data=allBrands
                > Download Brands
                </vue-json-to-csv>
              </div>
            </div>
            <div class="row">
              <div class="progress"
                 id="uploading-menu-csv-bar"
                 style="display: none"
            >
              <div id="progress-bar"
                   class="progress-bar progress-bar-danger progress-bar-striped active"
                   role="progressbar"
                   :style="{width: uploadMenuUsingCSV+'%'}"
                   :aria-valuenow="uploadMenuUsingCSV"
                   aria-valuemin="0"
                   aria-valuemax="100"
              >
                {{uploadMenuUsingCSV}}%
              </div>
            </div>
            </div>
            <div class="row" id="main-content" v-if="menu.length > 0">
                <div class="col-md-12">
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-3 category_panel">
                                <div class="theiaStickySidebar">
                                    <div class="panel panel-primary ">
                                        <div class="panel-heading">
                                            <b>Menu Categories</b>
                                        </div>
                                        <div class="panel-body" id="menu category_nav_bar">
                                            <ul class="nav">
                                                <li><a href="#most_popular">Most Popular</a></li>
                                                <li v-for="(category, index) in menu" v-if="!category.deleted"  v-bind:key="index+'cat_sidebar'">
                                                    <a v-bind:href="'#' + category.name.replace(/[ /]/g, '')+index" v-bind:title="category.name" v-bind:class="(category.name.length > 17) ? 'myTip link' : 'link'">
                                                        <span>{{(category.name.length > 17) ? category.name.substring(0,17)+'...' : category.name}}</span>
                                                        <span v-if="category.brandsByBrandsId"> - {{category.brandsByBrandsId.name}}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="panel panel-primary" >
                                    <div class="panel-heading">
                                        <b>Items</b>
                                    </div>
                                    <div class="panel-body">
                                        <section>
                                            <h3 id="most_popular" class="text-success"><b>Most Popular</b></h3>
                                            <ul class="list-group" >
                                                <template v-for="(mCategory, index) in menu" >
                                                    <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="menuItem.mostPopular && !menuItem.deleted" v-bind:key="indexMenuItem+'_popular_'+menuItem.name">
                                                        <div class="row">
                                                            <div class="col-md-7">
                                                                <b>{{menuItem.name}}</b>&emsp;<a
                                                                v-on:click="showAdOns(menuItem)">Show Ad On(s)</a> | <a
                                                                v-on:click="attachMenuItemImages(menuItem.id)"
                                                            >Attach Images
                                                            </a>
                                                              <p>{{menuItem.description}}</p>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <table class="menu_table hideTableBottom table table-hover">
                                                                    <tbody>
                                                                    <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-if="!menuItemType.deleted" v-bind:key="indexMenuItemType+'type_popular'">
                                                                        <td>{{menuItemType.serving}}&emsp;<a v-on:click="showAdOns(menuItemType)">Show Ad On(s)</a></td>
                                                                        <td class="text-center">{{menuItemType.price}} Rs.</td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>
                                        </section>
                                        <section v-for="(mCategory, index) in menu" v-if="!mCategory.deleted" v-bind:key="index+'cat_main_menu'">
                                            <h3 v-bind:id="mCategory.name.replace(/[ /]/g, '')+index" class="text-success">
                                              <b>{{mCategory.name}}</b>
                                              <b class="text-danger text-sm"
                                                 v-if="mCategory.brandsByBrandsId">
                                                ({{mCategory.brandsByBrandsId.name}})
                                              </b>
                                            </h3>
                                            <ul class="list-group">
                                                <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="!menuItem.deleted" v-bind:key="indexMenuItem+'item_main_menu'">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <p class="text-info m-b-n-xxs"><i>
                                                                <span v-if="menuItem.sale !==0 "> {{ menuItem.sale }}% </span>
                                                                <span v-else>no</span>
                                                                sale
                                                            </i></p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-7">
                                                            <b>{{menuItem.name}}</b>&emsp;
                                                          <a
                                                             v-on:click="disableDiscountOnMenuItem(menuItem.id, index, indexMenuItem)"
                                                          >
                                                            <i v-if="menuItem.disableDiscount" class="fa fa-toggle-off" title="Enable Discount"/>
                                                            <i v-else class="fa fa-toggle-on" title="Disable Discount"/>
                                                          </a>&emsp;
                                                          <a v-on:click="showAdOns(menuItem)">Show Ad On(s)</a> |
                                                          <a v-on:click="attachMenuItemImages(menuItem.id)"
                                                        >Attach Images
                                                        </a>
                                                            <p>{{menuItem.description}}</p>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <table class="menu_table hideTableBottom table table-hover">
                                                                <tbody>
                                                                <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-if="!menuItemType.deleted" v-bind:key="indexMenuItemType+'type_main_menu'">
                                                                    <td>{{menuItemType.serving}}&emsp;
                                                                      <a
                                                                         v-on:click="disableDiscountOnMenuItemServing(menuItemType.id, index, indexMenuItem, indexMenuItemType)"
                                                                      >
                                                                        <i v-if="menuItemType.disableDiscount" class="fa fa-toggle-off" title="Enable Discount"/>
                                                                        <i v-else class="fa fa-toggle-on" title="Disable Discount"/>
                                                                      </a>&emsp;<a v-on:click="showAdOns(menuItemType)">Show Ad On(s)</a></td>
                                                                    <td class="text-center" title="Sale Price">{{menuItemType.price}} Rs.</td>
                                                                    <td class="text-center" title="Cost Price">{{menuItemType.costPrice}} Rs.</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </section>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AddUpdateMenu ref="addUpdateMenuPopUp" @fetchBranchMenu="fetchBranchMenu"/>
        <!-- Ad - On Modal -->
        <div class="modal fade" id="adOnsPopUp" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" v-if="selectedAdOnCategory.name">Menu Item ({{ selectedAdOnCategory.name }}) Ad On(s)</h4>
                        <h4 class="modal-title" id="adOnsPopUpLabel" v-if="selectedAdOnCategory.serving">Menu Item Type ({{ selectedAdOnCategory.serving }}) Ad On(s)</h4>
                    </div>
                    <div class="modal-body">
                        <span v-if="noAdOns"><i>No Ad On(s) added for this Item</i></span>
                        <section v-for="adOnCat in adOns" v-if="!adOnCat.deleted" v-bind:key="'adon_cat_modal_' + adOnCat.id + Math.random()">
                            <b style="color: #1D84C6">{{adOnCat.addOnCategory.name.split('-->')[0] + ' (' + adOnCat.addOnCategory.allowedItems + ')'}}</b>
                            <div class="checkbox" v-for="adOnName in adOnCat.addOnCategory.addOnItemsById" v-bind:key="'adon_cat_item_modal_'+adOnName.id + Math.random()">
                                <span>{{adOnName.name + ' - ' + adOnName.price + ' Rs.'}}</span>
                            </div>
                        </section>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
      <ViewMenuItemImages ref="viewMenuItemImagesPopUp"/>
    </section>
</template>

<script>
    import PageTitle from "../components/layout_components/PageTitle";
    import User from '@/services/User'
    import AddUpdateMenu from "../components/restaurants/AddUpdateMenu";
    import Multiselect from 'vue-multiselect';
    import ViewMenuItemImages from "../components/restaurants/ViewMenuItemImages";
    import {applyDiscountOnMenuItem} from "@/api/restaurants";
    import VueJsonToCsv from 'vue-json-to-csv'
    import {fetchBranchMenuCsv, uploadMenuThroughCSV} from "@/api/menu";
    import {fetchAllBrands} from "@/api/brands";

    export default {
        name: "ViewMenu",
        data: function () {
            return {
                count: 0,
                restaurants: [],
                branches: [],
                menu: [],
                selectedRestaurant: "",
                selectedBranch: "",
                isHideSpinner: "hide",
                selectedAdOnCategory: [], //we will show this in popup
                noAdOns: false,
                swalInptValue:"",
                branchMenuCsv: [],
                uploadMenuUsingCSV: 0,
                uploadingItems: false,
                userRole:"",
                allBrands: []
            }
        },
        components: {ViewMenuItemImages, AddUpdateMenu, PageTitle, Multiselect, VueJsonToCsv},
        computed: {
            adOns: function () {
                let temp;
                if (this.selectedAdOnCategory.name) { 
                    temp= this.selectedAdOnCategory.menuItemAdOns 
                }
                else if (this.selectedAdOnCategory.serving) { 
                    temp= this.selectedAdOnCategory.menuItemTypeAdOns 
                }
                console.log("Menu ad ons: ", temp);
                return temp;
                
            }
        },
        updated: function () {
            $('.category_panel').theiaStickySidebar({
                additionalMarginTop: 20,
                containerSelector: "#main-content"
            });
            let $body   = $(document.body);
            let navHeight = $('.category_panel').outerHeight(true) + 10;
            $body.scrollspy({
                target: '.category_panel',
                offset: navHeight
            });
        },
        created() {
            this.userRole = this.$store.getters.user.userRolesById[0].role;
            User.fetchUserRoles().then(async role => {
                if (role === 'ROLE_ADMIN' || role === 'ROLE_AGENT') {
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                        this.restaurants = resp.data;
                        console.log(this.restaurants);
                    });
                    this.allBrands = await this.fetchAllBrands();
                } else if (role === 'ROLE_USER') {
                    this.selectedRestaurant = this.$store.state.user.restaurant;
                    this.restaurants.push({
                        id: this.$store.state.user.restaurant.id,
                        name: this.$store.state.user.restaurant.name
                    });
                    this.fetchBranchesOfRestaurant();
                }
            });
        },
        methods: {
            fetchAllBrands: async function () {
                let allBrands = await fetchAllBrands().catch( ex => {
                    this.showErrorMessage(ex)
                })
                if(allBrands.data.status === 200){
                    allBrands.data.body.length > 0 ? allBrands.data.body.forEach(function(v){ delete v.logo }) : allBrands.data.body;
                    return allBrands.data.body.length === 0 ? [{
                        "id": 0,
                        "name": ""
                    }] : allBrands.data.body;
                }else{
                    this.showErrorMessage("Error while fetching brands CSV data!");
                }
            },
            fetchFilename: function (name){
              return name.toLowerCase().replaceAll(" ",  "-")
            },
            fetchBranchMenuCsv: async function (){
              if(this.userRole === 'ROLE_ADMIN' || this.userRole === 'ROLE_AGENT') {
                console.log("Fetch branch menu CSV!")
                let branchMenuCsv = await fetchBranchMenuCsv(this.selectedBranch.id)
                    .catch(ex => {
                      this.showErrorMessage(ex)
                    });
                if (branchMenuCsv.data !== undefined && branchMenuCsv.data.status === 200) {
                  this.branchMenuCsv = branchMenuCsv.data.body;
                } else {
                  let message = (branchMenuCsv.data !== undefined) ? branchMenuCsv.data.message : branchMenuCsv.message;
                  this.showErrorMessage(message)
                }
                $('#fileUpload').val('')
              }
            },
            toggleDiscount: async function (params) {
              this.showLoading();
              let applyDiscountOnMenuItemResp = await applyDiscountOnMenuItem(this.selectedBranch.id, params)
                  .catch(ex => {
                    this.showErrorMessage(ex);
                  });
              if (applyDiscountOnMenuItemResp.data.status === 200) {
                swal("SUCCESS!", applyDiscountOnMenuItemResp.data.message, "success");
                return true;
              } else {
                swal("TRY AGAIN!", "Error while updating menu!", "error");
                return false;
              }
            },
            disableDiscountOnMenuItem: async function (menuItemId, menuCategoryIndex, menuItemIndex) {
              let params = new URLSearchParams();
              params.append("menu_item_id", menuItemId);
              if(await this.toggleDiscount(params)){
                let selectedMenuItem = this.menu[menuCategoryIndex].menuItemsById[menuItemIndex];
                for ( let servings of selectedMenuItem.menuItemTypesById){
                  servings.disableDiscount = !selectedMenuItem.disableDiscount
                }
                selectedMenuItem.disableDiscount = !selectedMenuItem.disableDiscount;
              }
            },
            disableDiscountOnMenuItemServing: async function (servingId, menuCategoryIndex, menuItemIndex, menuItemTypeIndex) {
              let params = new URLSearchParams();
              params.append("item_serving_id", servingId);
              if (await this.toggleDiscount(params)) {
                let selectedMenuItem = this.menu[menuCategoryIndex].menuItemsById[menuItemIndex];
                let selectedMenuItemType = selectedMenuItem.menuItemTypesById[menuItemTypeIndex];
                selectedMenuItemType.disableDiscount = !selectedMenuItemType.disableDiscount;
                if(selectedMenuItem.menuItemTypesById.every( servings => servings.disableDiscount === selectedMenuItemType.disableDiscount)){
                  selectedMenuItem.disableDiscount = selectedMenuItemType.disableDiscount
                }
                if(selectedMenuItem.menuItemTypesById.some( servings => servings.disableDiscount === false)) {
                  selectedMenuItem.disableDiscount = false
                }
              }
            },
            attachMenuItemImages: async function(menuItemId){
              await this.$refs.viewMenuItemImagesPopUp.load(menuItemId, this.selectedBranch.id);
            },
            fetchBranchesAndAddonsCSV: async function () {
              await this.fetchBranchesOfRestaurant();
            },
            fetchBranchesOfRestaurant: function () {
                let params = new URLSearchParams();
                params.append("restaurant_id", this.selectedRestaurant.id);
                if(this.selectedRestaurant !== ""){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                        console.log(resp.data);
                        this.branches = resp.data;
                    });
                }else{
                    this.branches = [];
                }
                this.selectedBranch = "";
                this.menu = []
            },
            fetchBranchMenu: function () {
                this.isHideSpinner = "";
                this.menu = [];
                let params3 = new URLSearchParams();
                if(this.selectedBranch === ""){
                    this.isHideSpinner = "hide";
                   return;
                }
                params3.append("branch_id", this.selectedBranch.id);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_branch_menu", params3).then(async resp => {
                  this.menu = resp.data;
                  this.isHideSpinner = "hide";
                  console.log(this.menu);
                  await this.fetchBranchMenuCsv();
                }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
            showAdOns: function(AdOns) {
                this.noAdOns = false;
                (AdOns.menuItemTypeAdOns) && ( (AdOns.menuItemTypeAdOns.length === 0) && ( this.noAdOns = true ));
                (AdOns.menuItemAdOns) && ( (AdOns.menuItemAdOns.length === 0) && ( this.noAdOns = true ));
                this.selectedAdOnCategory = $.extend(true, {}, AdOns);
                    $("#adOnsPopUp").modal("show");
            },
            updateMenu: function () {
                this.$refs.addUpdateMenuPopUp.load(this.selectedBranch.id, this.selectedRestaurant.id, this.selectedBranch.areasByAreaId.name);
            },
            setProgressBarStyle: function (display){
              this.uploadingItems = (display === 'flex');
              document.getElementById("uploading-menu-csv-bar").style.display = display;
              this.uploadMenuUsingCSV = 0;

            },
            uploadCSV: function (){
              document.getElementById("fileUpload").click()
            },
            showErrorMsgAndUpdateFilepath: function (ex){
              let fileUpload = $("#fileUpload")
              fileUpload.val('')
              this.showErrorMessage(ex)
            },
            handleFile: async function (event) {
              let self = this;
              let file = event.target.files[0];
              this.setProgressBarStyle("flex")
              let formData = new FormData();
              formData.append("csv_file", file)
              let config = {
                headers: {
                  'Content-Type': 'multipart/form-data;'
                },
                onUploadProgress: function (progressEvent) {
                  if (progressEvent.lengthComputable) {
                    self.uploadMenuUsingCSV = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                  }
                }.bind(self)
              }
              let uploadMenu = await uploadMenuThroughCSV(
                  this.selectedBranch.id, formData, config
              ).catch( ex =>
                this.showErrorMsgAndUpdateFilepath(ex)
              );
              if(uploadMenu !== undefined && uploadMenu.data !== undefined) {
                console.log("status: ", uploadMenu.data.status)
                if(uploadMenu.data.status === 400 || uploadMenu.data.status === 404){
                  this.showErrorMsgAndUpdateFilepath(uploadMenu.data.body[0])
                }else if (uploadMenu.data.status === 200) {
                  swal("SUCCESS!", "Successfully update menu through CSV!", "success");
                  this.fetchBranchMenu()
                } else {
                  this.showErrorMsgAndUpdateFilepath(uploadMenu.data.message)
                }
              }
              this.setProgressBarStyle("none")
            },
            editItem: function(menuItem){
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                let params= new URLSearchParams();
                params.append("menu_item_id", menuItem.id);
                this.$http.post(this.$store.state.mainAppURL + "restaurants/check_is_menu_item_editable", params).then(resp=>{
                    Swal.close();
                    if(resp.data){
                        let self= this;
                        self.swalInptValue= menuItem.name;
                        const { value: newMenuItemName} = Swal.fire({
                            title: "Edit Menu Item",
                            input: 'text',
                            inputValue: self.swalInptValue,
                            showCancelButton: true,
                            confirmButtonText: 'Save',
                            showLoaderOnConfirm: true,
                            preConfirm: (newMenuItemName) => {
                                console.log(newMenuItemName);
                                let params= new URLSearchParams();
                                params.append("menu_item_id",menuItem.id);
                                params.append("item_name", newMenuItemName);
                                params.append("branch_id", this.selectedBranch.id);
                                this.$http.put(this.$store.state.mainAppURL + "restaurants/update_menu_item_name", params).then(resp=>{
                                    swal("SUCCESS!", "Item Name Has Been Updated", "success");
                                    this.fetchBranchMenu();
                                })
                            },
                            allowOutsideClick: () => !Swal.isLoading(),
                            inputValidator: (value) => {
                                if (!value) {
                                return 'Item Name Cannot Be Empty'
                                }
                            }
                        });
                    }else{
                        swal("Error!", "Cannot Update This Item", "error");
                    }
                });
            },
        },
        
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
